<div class="link-fields">
  <fieldset class="link-fields__grupo">
    <legend class="link-fields__titulo">
      <i class="pi pi-briefcase" aria-hidden="true"></i> Empresa, parceiro e deal
    </legend>
    <p class="link-fields__descricao">
      Parceiro, deal e deal do pipeline de crédito são da empresa escolhida.
    </p>

    <app-select
      [label]="'Empresa'"
      [placeholder]="carregandoEmpresas() ? 'Carregando empresas...' : 'Selecione a empresa'"
      [options]="empresas()"
      [loading]="carregandoEmpresas()"
      [allowEmptyPlaceholderSelect]="true"
      [emptyMessage]="'Nenhuma empresa encontrada.'"
      [ngModel]="empresa"
      (ngModelChange)="aoEscolherEmpresa($event)" />

    <app-select
      [label]="'Parceiro'"
      [placeholder]="!empresa ? 'Escolha a empresa primeiro' : 'Sem parceiro'"
      [options]="parceiros()"
      [loading]="carregandoDaEmpresa()"
      [disabled]="!empresa"
      [allowEmptyPlaceholderSelect]="true"
      [emptyMessage]="'Nenhum parceiro ligado a esta empresa.'"
      [ngModel]="parceiro"
      (ngModelChange)="aoEscolherParceiro($event)" />

    <app-select
      [label]="'Deal'"
      [placeholder]="!empresa ? 'Escolha a empresa primeiro' : 'Sem deal'"
      [options]="opcoesDeDeal()"
      [loading]="carregandoDaEmpresa()"
      [disabled]="!empresa"
      [allowEmptyPlaceholderSelect]="true"
      [emptyMessage]="
        parceiro ? 'Nenhum deal deste parceiro na empresa.' : 'Nenhum deal ativo nesta empresa.'
      "
      [ngModel]="deal"
      (ngModelChange)="aoEscolherDeal($event)" />

    <app-select
      [label]="'Deal do pipeline de crédito'"
      [placeholder]="!empresa ? 'Escolha a empresa primeiro' : 'Sem deal do pipeline'"
      [options]="opcoesDeDealDoPipeline()"
      [loading]="carregandoDaEmpresa()"
      [disabled]="!empresa"
      [allowEmptyPlaceholderSelect]="true"
      [emptyMessage]="'Nenhum deal do pipeline de crédito nesta empresa.'"
      [ngModel]="dealDoPipeline"
      (ngModelChange)="aoEscolherDealDoPipeline($event)" />
  </fieldset>

  <fieldset class="link-fields__grupo">
    <legend class="link-fields__titulo">
      <i class="pi pi-building-columns" aria-hidden="true"></i> Relacionamento bancário
    </legend>
    <p class="link-fields__descricao">Banco e contato bancário da mesma empresa.</p>

    <app-select
      [label]="'Relacionamento bancário'"
      [placeholder]="!empresa ? 'Escolha a empresa primeiro' : 'Sem banco'"
      [options]="opcoesDeRelacionamento()"
      [loading]="carregandoDaEmpresa()"
      [disabled]="!empresa"
      [allowEmptyPlaceholderSelect]="true"
      [emptyMessage]="'Nenhum relacionamento bancário nesta empresa.'"
      [ngModel]="relacionamento"
      (ngModelChange)="aoEscolherRelacionamento($event)" />

    <app-select
      [label]="'Contato bancário'"
      [placeholder]="!relacionamento ? 'Escolha o relacionamento primeiro' : 'Sem contato'"
      [options]="opcoesDeContato()"
      [disabled]="!relacionamento"
      [allowEmptyPlaceholderSelect]="true"
      [emptyMessage]="'Nenhum contato neste relacionamento.'"
      [ngModel]="contato"
      (ngModelChange)="aoEscolherContato($event)" />
  </fieldset>
</div>
